const collectionSelectors = {
    readMoreBtn: document.querySelector('[data-readMoreBtn]'),
    readMoreContainer: document.querySelector('[data-readMoreContainer]')
  };
  class templateCollectionJS {
    constructor() {
        this.readMore();
    }

    readMore(){
        if(collectionSelectors.readMoreBtn){
            collectionSelectors.readMoreBtn.addEventListener('click', (e)=>{
                e.preventDefault();
                let currentTarget = e.target;
                let readMoreEle = collectionSelectors.readMoreContainer.querySelector('.hidden-text');
                if(readMoreEle){
                    if(collectionSelectors.readMoreContainer.classList.contains('open')){
                        Utility.toggleElement(collectionSelectors.readMoreContainer, 'close');
                        currentTarget.innerHTML = 'Read More'
                    }else{
                        Utility.toggleElement(collectionSelectors.readMoreContainer, 'open');
                        currentTarget.innerHTML = 'Read Less'
                    }
                }
            });
        }
    }
}

typeof templateCollectionJS !== 'undefined' && new templateCollectionJS();

